import { render, staticRenderFns } from "./Study_plan.vue?vue&type=template&id=669f9bdc"
import script from "./Study_plan.vue?vue&type=script&lang=js"
export * from "./Study_plan.vue?vue&type=script&lang=js"
import style0 from "./Study_plan.vue?vue&type=style&index=0&id=669f9bdc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports